<template>
	<view>
		<view class="list">
			<view class="list-call">
				<u--input
					v-model="username"
					clearable
					maxlength="32"
					type="text"
					placeholder="请输入用户名"
					prefixIcon="account"
					prefixIconStyle="font-size: 22px;color: #909399"
				></u--input>
			</view>
			<view class="list-call">
				<u--input
					v-model="password"
					clearable
					maxlength="32"
					type="password"
					placeholder="请输入密码"
					prefixIcon="lock"
					prefixIconStyle="font-size: 22px;color: #909399"
				></u--input>
			</view>
		</view>
		<view class="loginBtn"><u-button type="primary" text="登录" @click="submit()"></u-button></view>
	</view>
</template>

<script>
import { apiLoginPassword } from '@/api/publicInterface.js';
import { mapMutations } from 'vuex';
import { setToken, setRefreshToken, setUsernameKey, setCustomerId, redirectHome } from '@/utils/status.js';
export default {
	name: 'userPassword',
	data() {
		return {
			// username: 'appUser',
			// username:'siJi1',
			username:'siJi2',
			password: '123456',
			remember: true,
			baseUrl: ''
		};
	},
	methods: {
		...mapMutations(['setUserTabbar']),
		//登录
		async submit() {
			//表单校验
			if (this.username.length === 0) {
				this.$u.toast('请输入账号');
				return;
			}
			if (this.password.length === 0) {
				this.$u.toast('请输入密码');
				return;
			}
			let grant_type = 'password'
			//登录接口
			await apiLoginPassword({
				username: this.username,
				password: this.password,
				grant_type,
				scope: 'server'
			})
				.then(res => {
					this.$u.toast('恭喜您，登录成功！');
					
					// 登陆成功，存储相关信息
					setToken(res.access_token);
					setRefreshToken(res.refresh_token);
					setUsernameKey(res.username);
					
					//查询用户详细信息并储存
					this.$reqGet('getUserEntity').then(res => {
						this.setUserTabbar(res.data.type);
						uni.setStorageSync('roleType', res.data.type);
						setCustomerId(res.data.customerid);
						
						//跳转页面
						this.$nextTick(() => {
							redirectHome();
						});
					});
				})
				.catch(e => {
					this.$u.toast(e);
				});
		}
	}
};
</script>

<style lang="scss">
@import 'index.scss';
.dengluBtn {
	margin-top: 80rpx;
}
</style>
